<template>
  <div class="content">
    <!-- 页面标题 -->
    <div v-wechat-title="'景天的唐家堡历练'"></div>

    <!-- 首页进入青瓷游戏LOGO -->
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut" name="fade">
      <div @touchmove.prevent class="preloading preloading-xj" v-show="count < 100">
        <div class="loading_bg">

          <div class="loading">
            <div class="loading_line">

              <div class="dot" :style="{ left: dotLeft + 'px' }"></div>
            </div>
          </div>
          <div class="loading_text">
            <div class="progress-percent">{{ count }}%</div>
          </div>

        </div>

        <div class="progress-message">
          <img :src="loadingMessageImage" />
        </div>

        <div class="progress-role">
        </div>
      </div>
    </transition>


    <!-- 移动端 -->
    <div :class="['main-container', activeTab]" id="xj-main-mobile" ref="mobile">
      <!-- 头部 -->
      <header class="xj_header" :class="'xj-new-header-login-' + headerLogin">
        <div class="acco">{{ user_info.user_id ? `${user_info.role_name} ${user_info.server_name ?
          `[${user_info.server_name}]` : ''}` : '请先登录' }}</div>
        <a class="download-btn-new" title="下载按钮" @click="goOfficeWeb"></a>
        <a v-if="!user_info.user_id" class="new-logon-btn" @click="logon()" title="登录&切换按钮"></a>
        <a v-if="user_info.user_id && (userInfo.os !== 'allChannel_zs' || userInfo.os !== 'allChannel_gz')"
          class="new-switch-btn" @click="switchBtn()"></a>
        <a v-if="user_info.user_id && (userInfo.os == 'allChannel_zs' || userInfo.os == 'allChannel_gz')"
          class="new-logout-btn" @click="qhBtn()"></a>
      </header>

      <!-- <div class="bg-image"></div> -->

      <!-- 底部 tab 导航栏 -->
      <!-- 整体 tab 显示为一个图 -->
      <div class="tab-wrapper" @click="toggleTab" v-if="!helpId">
        <img :src="activeTab === 'tab1' ? tab1Img : tab2Img" alt="tab切换图">
      </div>
      <div class="tab-wrapper" v-else @click="backMyShop">
        <img :src="helpImg" alt="tab切换图">
      </div>
      <div class="tab1-content" v-if="activeTab == 'tab1'">
        <!-- 任务列表 -->

        <div class="role-one"></div>
        <div class="bottom-bg-one"></div>

        <div class="task-list">
          <div class="task-scroll-wrapper">
            <div class="task-item" v-for="(item, index) in task_info" :key="item.id" :class="{
              'bg-task-1': item.id >= 1 && item.id <= 4,
              'bg-task-2': item.id === 5
            }">
              <!-- task-desc：描述文字的位置 -->
              <div class="task-desc" :class="'desc-pos-' + index">
                {{ item.desc }}({{ item.status == 2 || item.status == 1 ? '1/1' : '0/1' }})
              </div>

              <!-- 状态按钮，根据 status 状态和 index 设置样式 -->
              <div class="task-status-btn" :class="['status-' + item.status, 'button-pos-' + index]"
                @click="claimReward(item)"></div>
            </div>
            <div class="scroll-ghost"></div>
          </div>
        </div>


        <div class="people-name">
          <!-- 玩家xxx的永安当 -->
          <span v-if="user_info.role_name">
            {{ user_info.role_name }}的永安当</span>
        </div>
        <div class="people-coin">
          <div class="left-coin">
            <span>{{ total_money }}</span>
          </div>
          <div class="right-coin">
            <span>{{ total_score }}</span>
          </div>
        </div>
        <!-- 下拉按钮 -->
        <div class="draw-btn" @click="handleDrawClick"
          :class="{ 'is-animating': isAnimating, 'draw-hint': isDrawHint }"></div>
        <!-- 规则按钮 -->
        <div class="rule-btn" @click="popSwitch('ruleShow', true)"></div>

        <!-- 记录按钮 -->
        <div class="history-btn" @click="hasHistory"></div>
      </div>


      <div class="tab2-content" v-if="activeTab === 'tab2'">
        <div class="today-sell"><span>{{ today_price }}</span></div>

        <div class="role-two"></div>
        <div class="bottom-bg-two"></div>

        <!-- 出售容器 -->
        <div class="sell-container">
          <div class="day-sell"><span>20</span><span class="ge-style">个</span></div>
          <div class="can-sell"><span>{{ now_can_sell_number }}</span><span v-if="now_can_sell_number"
              class="ge-style">个</span></div>
          <div class="text-tip"></div>

          <div class="share-btn" @click="clickShare"></div>
          <div class="sell-btn" @click="clickSell"></div>
        </div>


        <!-- 下拉按钮 -->
        <div class="draw-btn" @click="handleDrawClick"
          :class="{ 'is-animating': isAnimating, 'draw-hint': isDrawHint }"></div>

        <div class="top-flex">
          <div class="people-name">
            <!-- 玩家xxx的永安当 -->
            <span v-if="user_info.role_name">
              {{ user_info.role_name }}的永安当</span>
          </div>
          <div class="people-coin">
            <div class="left-coin">
              <span>{{ total_money }}</span>
            </div>
            <div class="right-coin">
              <span>{{ total_score }}</span>
            </div>
          </div>
        </div>

        <!-- 规则按钮 -->
        <div class="rule-btn" @click="popSwitch('ruleShow', true)"></div>

        <!-- 记录按钮 -->
        <div class="history-btn" @click="hasHistory"></div>
      </div>

      <div class="tab3-content" v-if="activeTab === 'tab3'">
        <div class="today-sell"><span>{{ now_shop_price }}</span></div>

        <div class="role-two"></div>
        <div class="bottom-bg-two"></div>

        <!-- 出售容器 -->
        <div class="sell-container">
          <div class="day-sell"><span>{{ other_can_buy_number }}</span><span v-if="other_can_buy_number"
              class="ge-style">个</span></div>
          <div class="can-sell"><span>{{ other_now_can_sell_number }}</span><span v-if="other_now_can_sell_number"
              class="ge-style">个</span></div>
          <div class="sell-btn" @click="clickOtherSell"></div>
        </div>


        <div class="top-flex">
          <div class="people-name">
            <!-- 玩家xxx的永安当 -->
            <span v-if="shopName">
              {{ shopName }}的永安当</span>
          </div>
          <div class="people-coin">
            <div class="left-coin">
              <span>{{ total_money }}</span>
            </div>
            <div class="right-coin">
              <span>{{ total_score }}</span>
            </div>
          </div>
        </div>

        <!-- 规则按钮 -->
        <div class="rule-btn" @click="popSwitch('ruleShow', true)"></div>
      </div>
      <div v-else>
        <!-- 地底副本内容 -->
      </div>




      <!-- 商店弹窗 -->
      <div class="shop-wrap popup_wrap" v-show="shopShow || animating">
        <transition name="popup-rise" appear @before-enter="onBeforeEnter" @after-leave="onAfterLeave">
          <div v-if="shopShow" class="shop-box popup_wrap-box">
            <div class="shop-container-grid">
              <div class="shop-item" v-for="(item, index) in package_info" :key="index" @click="buyItem(item)">
                <div class="item-bg">
                  <div class="item-content">
                    <p class="remark">{{ item.remark }}</p>
                    <div class="item-img">
                      <img class="item-icon" :src="getItemImg(item)" />
                    </div>
                    <p class="limit">限购{{ item.buy_number }}/{{ item.limit }}</p>
                    <p class="price">{{ item.number }} </p>
                  </div>
                </div>
              </div>
            </div>
            <!-- 锁层一 -->
            <div v-if="lockMaskStatus.lock1" class="lock-mask lock-mask-1"></div>

            <!-- 锁层二 -->
            <div v-if="lockMaskStatus.lock2" class="lock-mask lock-mask-2"></div>
            <div class="close-btn" @click="popSwitch('shopShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('shopShow', false)"></div>
      </div>

      <!-- 规则弹窗 -->
      <div class="rule-wrap popup_wrap" v-show="ruleShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="rule-box popup_wrap-box" v-show="ruleShow">
            <div class="close-btn" @click="popSwitch('ruleShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('ruleShow', false)"></div>
      </div>

      <!-- 购买弹窗 -->
      <div class="buy-wrap popup_wrap" v-show="buyItemShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="buy-box popup_wrap-box" v-show="buyItemShow">
            <div class="shop-item">
              <div class="item-bg">
                <div class="item-content">
                  <p class="remark">{{ click_item.remark }}</p>
                  <div class="item-img">
                    <img class="item-icon" :src="getItemImg(click_item)" />
                  </div>
                  <p class="price">{{ click_item.number }} </p>
                </div>
              </div>
            </div>
            <div class="confirm-btn" @click="confirmBuy"></div>
            <div class="cancel-btn" @click="popSwitch('buyItemShow', false)"></div>
            <div class="close-btn" @click="popSwitch('buyItemShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('buyItemShow', false)"></div>
      </div>

      <!-- 铜币不足 -->
      <div class="empty-wrap popup_wrap" v-show="emptyShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="empty-box popup_wrap-box" v-show="emptyShow">

            <div class="go-btn" @click="closeEmpty"></div>
            <div class="close-btn" @click="popSwitch('emptyShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('emptyShow', false)"></div>
      </div>

      <!-- 出售玉龙 -->
      <div class="sell-wrap popup_wrap" v-show="sellShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="sell-box popup_wrap-box" v-show="sellShow">
            <!-- 今日收购单价 -->
            <div class="today-number">{{ today_price }}</div>

            <!-- - 减号按钮 -->
            <div class="reduce" @click="decrement"></div>

            <!-- 当前准备出售的数量 -->
            <div class="number">
              <span>{{ currentSellCount }}</span>
            </div>

            <!-- + 加号按钮 -->
            <div class="add" @click="increment"></div>

            <!-- 最大按钮 -->
            <div class="max" @click="setMax"></div>

            <div class="sell-btn" @click="confirmSell"></div>

            <div class=" close-btn" @click="closeSellShow"></div>
          </div>
        </transition>
        <div class="close-bg" @click="closeSellShow"></div>
      </div>


      <!-- 链接出售玉龙 -->
      <div class="sell-wrap popup_wrap" v-show="otherSellShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="sell-box popup_wrap-box" v-show="otherSellShow">
            <!-- 今日收购单价 -->
            <div class="today-number">{{ now_shop_price }}</div>

            <!-- - 减号按钮 -->
            <div class="reduce" @click="decrement"></div>

            <!-- 当前准备出售的数量 -->
            <div class="number">
              <span>{{ currentSellCount }}</span>
            </div>

            <!-- + 加号按钮 -->
            <div class="add" @click="increment"></div>

            <!-- 最大按钮 -->
            <div class="max" @click="setMax"></div>

            <div class="sell-btn" @click="OtherConfirmSell"></div>

            <div class=" close-btn" @click="closeOtherSellShow"></div>
          </div>
        </transition>
        <div class="close-bg" @click="closeOtherSellShow"></div>
      </div>

      <!-- 无数据时候的交易记录 -->
      <div class="no-record-wrap popup_wrap" v-show="noRecordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="no-record-box popup_wrap-box" v-show="noRecordShow">
            <div class="close-btn" @click="popSwitch('noRecordShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('noRecordShow', false)"></div>
      </div>

      <!-- 有数据时候的交易记录 -->
      <div class="record-wrap popup_wrap" v-show="recordShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="record-box popup_wrap-box" v-show="recordShow">
            <div class="record-list">
              <div class="record-item" v-for="(item, index) in score_record_list" :key="index">
                <div class="record-row">
                  <span class="record-time">{{ item.updated_at }}</span>
                  <span class="record-type">{{ getRecordTypeName(item.type, item) }}</span>
                  <span class="record-coin" :class="{ income: isIncome(item.type), expense: !isIncome(item.type) }">
                    {{ getCoinPrefix(item.type) + Math.abs(item.money) }}
                  </span>
                </div>
                <div v-if="index !== score_record_list.length - 1" class="record-divider"></div>
              </div>
            </div>
            <div class="close-btn" @click="popSwitch('recordShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('recordShow', false)"></div>
      </div>


      <!-- 分享相关DOM -->
      <div class="share-box-xj" ref="imageDom">
        <img src="https://download4.qcplay.com/qcgame-api/koYFJF2lo5xivaNo9bwwoUPFav3EEoOb4EODwbTY.png" />
        <div class="qrcode-box">
          <div id="qrcode" class="qrcode"></div>
        </div>
        <!--  ✨ 新增 today_price 展示 -->
        <div class="share-sell-xj">{{ today_price }}</div>
      </div>

      <!-- 分享弹窗 -->
      <div :class="'help-share-wrap popup_wrap help-share-wrap-' + shareShow">
        <transition enter-active-class="animated fadeIn" leave-active-class="animated fade-leave-active"
          :duration="{ enter: 1000 }" v-show="shareShow">
          <div class="help-share-box popup_wrap-box">
            <div class="bottom-img">
              <div class="qrcode-box">
                <div id="qrcode2" class="qrcode"></div>
              </div>
            </div>
            <img :src="shareImg" alt="分享图片" />
            <div class="share-sell">{{ today_price }}</div>
            <div class="go-tap" @click="goTap"></div>
            <div class="clipboard-btn" @click="copyLink('.clipboard-btn')" data-event="复制活动链接"
              :data-clipboard-text="`【新仙剑】今日我的铺子收玉价为${today_price}，现在还能收购${now_can_sell_number}个，快来光顾吧~点击链接：https://h5.qingcigame.com/hjwq/aniEvent/enter?help_id=${userId}`">
            </div>
            <div class="close-btn" @click="popSwitch('shareShow', false)"></div>
          </div>
        </transition>
        <div class="close-bg" @click="popSwitch('shareShow', false)"></div>
      </div>


      <!-- 注销弹窗 -->
      <div class="logout-wrap popup_wrap" v-show="logoutShow">
        <transition enter-active-class="animated zoomInNew" leave-active-class="animated zoomOutRight"
          :duration="{ enter: 1000 }">
          <div class="logout-box popup_wrap-box" v-show="logoutShow">
            <p>是否退出当前账号</p>
            <a class="left-btn" href="javascript:;" @click="logoutShow = false">取消</a>
            <a class="right-btn" href="javascript:;" @click="logoutBtn()">确定</a>
          </div>
        </transition>
      </div>

      <!-- 登录弹窗 -->
      <Login v-if='isShowLogin' noAuthLogin v-on:channelCallback='onBind()' :gameName="gameName"
        :loginTypes='loginTypes' :downloadUrl='downloadUrl' channelTips='角色UID可在游戏中—设置—UID查看'>
      </Login>

      <!-- 绑定弹窗 -->
      <Os v-if='isShowOs' v-on:selectCallback='onBind()' v-on:logoutCallback='osCancel' :gameName='gameName'></Os>
    </div>
  </div>
</template>

<script>
const COMMON_FIELDS = [
  'total_money',
  'total_score',
  'package_info',
  'now_can_sell_number',
  'score_record_list',
  'today_price'
];
import { LogoutAPI } from "@/api/login";
import _ from "lodash";
import Clipboard from 'clipboard';
import { Toast, Indicator } from 'mint-ui';
import { onInitAPI, onGetRewardAPI, onBuyItemAPI, onSellItemAPI, onHelpInitAPI, otherSellItemAPI, noSecretLoginAPI } from '../api'
import { mapState, mapMutations, mapActions } from 'vuex'
import { getTimeStamp, analysisParams, buriedLogger, getRandomString } from '@/utils/utils';
import Os from '@/components/os';
import Login from '../login'
import Footer from '@/components/Footer';
import { generateQRCode, generateCanvasImage } from '@/utils/share';

export default {
  name: 'ani-event',
  components: {
    Login,
    Footer,
    Os
  },
  data() {
    return {
      sellTimerOther: null, // OtherConfirmSell专用防抖定时器
      sellTimer: null, // 定时器
      downloadUrl: 'https://hjwq.qingcijoy.com/',
      itemImages: {
        1: 'https://download4.qcplay.com/hjwq/aniEvent/home/1.png',
        2: 'https://download4.qcplay.com/hjwq/aniEvent/home/2.png',
        3: 'https://download4.qcplay.com/hjwq/aniEvent/home/3.png',
        4: 'https://download4.qcplay.com/hjwq/aniEvent/home/4.png',
        5: 'https://download4.qcplay.com/hjwq/aniEvent/home/5.png',
        6: 'https://download4.qcplay.com/hjwq/aniEvent/home/6.png',
        7: 'https://download4.qcplay.com/hjwq/aniEvent/home/7.png',
        8: 'https://download4.qcplay.com/hjwq/aniEvent/home/8.png',
        9: 'https://download4.qcplay.com/hjwq/aniEvent/home/9.png'
      },
      shopName: '',// 别人的当铺名
      can_buy_number: '', // 每日上限
      other_can_buy_number: '', // 别人的每日上限
      other_now_can_sell_number: '', // 别人还能卖多少
      userId: '', // 用户邀请的id

      helpId: '', // 判断tab

      now_shop_price: '', // 今天别人商店的玉价


      today_price: '', // 今天的玉价
      now_can_sell_number: '',
      isAnimating: false, //  下拉动画
      isDrawHint: false,
      drawHintTimer: null,

      currentSellCount: 0,

      total_money: '', // 铜钱
      total_score: '', // 古龙

      score_record_list: [],
      recordShow: false,
      noRecordShow: false,
      sellShow: false, // 出售古龙
      otherSellShow: false, // 链接出售古玉
      emptyShow: false, // 铜币不足弹窗
      click_item: '', // 当前点击选中的item 就是商店购买的 
      package_info: [],
      task_info: [
        { id: 1, desc: '今日完成1次游戏登录', status: 0 },
        { id: 2, desc: '今日完成1次组队副本', status: 0 },
        { id: 3, desc: '今日完成1次比武大会', status: 0 },
        { id: 4, desc: '挑战1次世界悬赏', status: 0 },
        { id: 5, desc: '打开1次仙盟宴会伴手礼', status: 0 },
      ],
      buyItemShow: false, // 是否需要购买此物品
      shopShow: false, //商店弹窗
      ruleShow: false, // 规则弹窗
      tab1Img: 'https://download4.qcplay.com/hjwq/aniEvent/home/tab_1.png',
      tab2Img: 'https://download4.qcplay.com/hjwq/aniEvent/home/tab_2.png',
      helpImg: 'https://download4.qcplay.com/hjwq/aniEvent/home/tab_3.png',
      activeTab: 'tab1', // 默认选中“图鉴”tab

      eggShow: false,     // 控制是否弹出
      animating: false,    // 控制父容器是否仍显示

      count: 20,
      loginTypes: ["sms", "password", "channel"],
      headerLogin: false,
      gameName: 'hjwq',
      shareImg: '',
      user_info: {}, // 用户信息
      shareShow: false,
      logoutShow: false,
    }
  },
  computed: {
    lockMaskStatus() {
      const layer1 = this.package_info.slice(3, 6); // 第4/5/6项
      const layer2 = this.package_info.slice(6, 9); // 第7/8/9项

      return {
        lock1: !layer1.some(item => item.is_lock), // ❗如果 4-6 中“没有解锁”，就显示锁1
        lock2: !layer2.some(item => item.is_lock), // ❗如果 7-9 中“没有解锁”，就显示锁2
      };
    },

    // 进度条总宽度 = 576px
    dotLeft() {
      const maxWidth = 576;
      const dotWidth = 37;
      const progress = Math.min(this.count / 100, 1); // 如果 count 是 0 - 100
      return progress * maxWidth - dotWidth / 2; // 保持 dot 中线和进度尾部对齐
    },

    loadingMessageImage() {
      return this.count <= 50
        ? 'https://download4.qcplay.com/hjwq/aniEvent/home/text_1.png'
        : 'https://download4.qcplay.com/hjwq/aniEvent/home/text_2.png';
    },
    ...mapState([
      'userInfo',
      'activeInfo',
      'isShowLogin',
      'isShowOs'
    ])
  },
  mounted() {
    this.$nextTick(() => {
      this.startDrawHintLoop();

      this.setFavicon('https://download4.qcplay.com/qcgame-api/hVlQS8EiPXGmT1IAXVuet1fv2Ded0JQ8Ja8TKyda.png');

      const { token } = analysisParams(window.location.href);
      if (token) {
        noSecretLoginAPI({ token })
          .then((response) => {
            if (response.code == 200) {
              this.onInit()
              // 无刷新路由替换
            } else {
              this.onToast(response.message)
            }
          })
      } else {
        this.onInit();
      }

      const params = analysisParams(window.location.href);
      this.helpId = params.help_id

      if (params.help_id) {
        this.activeTab = 'tab3'
        onHelpInitAPI({ help_id: this.helpId }).then((response) => {
          if (Number(response.code) === 200) {
            this.now_shop_price = response.data.activity.now_shop_price
            this.other_now_can_sell_number = response.data.activity.now_can_sell_number
            this.other_can_buy_number = response.data.activity.can_buy_number
            this.shopName = response.data.activity.shop_name
          } else {
            Number(response.code) !== 401 && this.onToast(response.message);
          }
        });
      }

      console.log('1111', window.localStorage.getItem('access_token'))
      if (params.help_id && !window.localStorage.getItem('access_token')) {
        this.changeLoginPopup(true)
        setTimeout(() => {
          this.onToast('请先登录')
        }, 2200);
        return false
      }

      var linkUrl = `https://h5.qingcigame.com/hjwq/aniEvent/enter${getRandomString()}`;
      this.isSetShare(linkUrl);

      // this.monitoringEquipment();
    })
  },
  created() {
    this.incrementTo100(); // 进度条

    // 清空store上的用户数据
    this.setInitActiveInfo()
    this.setInitUserInfo()
    // const bl = buriedLogger('tideng', '提灯新版本上线h5');
    // this.logger = bl
  },
  // 在watch中监听用户ID变化
  watch: {
  },
  methods: {
    goTap() {
      window.location.href = 'https://l.taptap.cn/seGDPJYV?channel=rep-rep_vaflzacydgi'
    },
    setFavicon(url) {
      // 先移除旧的 favicon link 标签
      const existingIcons = document.querySelectorAll("link[rel~='icon']");
      existingIcons.forEach(el => el.parentNode.removeChild(el));

      // 创建新的 favicon 标签
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png'; // 可根据你的实际图片类型设置
      link.href = url;

      // 加入 <head>
      document.head.appendChild(link);
    },

    closeOtherSellShow() {
      this.otherSellShow = false
      this.currentSellCount = 0
    },
    closeSellShow() {
      this.sellShow = false
      this.currentSellCount = 0
    },
    batchSetActivityData(activityData, extraFields = []) {
      const allFields = [...COMMON_FIELDS, ...extraFields];
      allFields.forEach(key => {
        if (key in activityData) {
          this[key] = activityData[key];
        }
      });
    },
    getRecordTypeName(type, item) {
      const map = {
        1: item ? `完成任务获得${item.score}个古玉` : '完成任务获得多少个古玉',
        2: '消耗古玉获得铜钱',
        3: '兑换道具消耗',
        4: '玩家额外获得铜钱',
        5: '在别人当铺兑换古玉获得铜钱'
      };
      return map[type] || `未知类型(${type})`;
    },

    getCoinPrefix(type) {
      // Type 1、2、4、5 认为是获得
      const gainTypes = [1, 2, 4, 5];
      return gainTypes.includes(type) ? '+' : '-';
    },

    isIncome(type) {
      return this.getCoinPrefix(type) === '+'
    },

    clickOtherSell() {
      if (!this.checkLogin()) {
        return;
      }
      this.otherSellShow = true
    },
    clickSell() {
      if (!this.checkLogin()) {
        return;
      }
      this.sellShow = true
    },
    backMyShop() {
      this.activeTab = 'tab1'
      this.helpId = ''
    },
    getItemImg(item) {
      return this.itemImages[item.id] || ''
    },
    async confirmSell() {
      // --- 先做防抖 ---
      if (this.sellTimer) {
        // 如果短时间内再次点击，直接return掉
        return;
      }

      // 每次点击都设置一个500ms定时器
      this.sellTimer = setTimeout(() => {
        this.sellTimer = null; // 500ms后清空 timer，允许下次点击
      }, 900);

      // ---- 正式开始执行你的出售逻辑 ----
      if (this.currentSellCount == 0) {
        this.onToast('请选择出售数量');
        return;
      }

      const res = await onSellItemAPI({ number: this.currentSellCount });
      if (Number(res.code) === 200) {

        this.batchSetActivityData(res.data.activity);


        this.currentSellCount = 0;
        this.onToast(`获得铜钱${res.data.money}文！`);
        this.popSwitch('sellShow', false);
      } else {
        this.onToast(res.message);
      }
    },

    async OtherConfirmSell() {
      // --- 500ms防抖 ---
      if (this.sellTimerOther) {
        // 500ms内又点击，直接return
        return;
      }

      // 500ms冷却开始
      this.sellTimerOther = setTimeout(() => {
        this.sellTimerOther = null;
      }, 900);

      if (this.currentSellCount == 0) {
        this.onToast('请选择出售数量');
        return;
      }

      const res = await otherSellItemAPI({
        number: this.currentSellCount,
        help_id: this.helpId
      });

      if (Number(res.code) === 200) {
        this.total_score = res.data.activity.total_score // 6
        this.package_info = res.data.activity.package_info // 2
        this.other_now_can_sell_number = res.data.activity.now_can_sell_number // 1
        this.other_can_buy_number = res.data.activity.can_buy_number
        this.score_record_list = res.data.activity.score_record_list // 3
        this.today_price = res.data.activity.today_price // 4   
        this.total_money = res.data.activity.total_money // 5

        this.currentSellCount = 0;
        this.onToast(`获得铜钱${res.data.money}文！`);
        this.popSwitch('otherSellShow', false);
      } else {
        this.onToast(res.message);
      }
    },

    increment() {
      if (this.currentSellCount < this.total_score) {
        this.currentSellCount++;
      } else {
        this.onToast('已达最大可售数量');
      }
    },

    decrement() {
      if (this.currentSellCount > 0) {
        this.currentSellCount--;
      } else {
        this.onToast('数量不能小于0');
      }
    },

    setMax() {
      if (this.currentSellCount === this.total_score) {
        this.onToast('已达最大可售数量');
      } else {
        this.currentSellCount = this.total_score;
      }
    },
    clickShare() {
      if (!this.checkLogin()) {
        return;
      }
      setTimeout(() => {
        let qrUrl = `https://h5.qingcigame.com/hjwq/aniEvent/enter${getRandomString()}?help_id=${this.userId}`
        this.qrcode('qrcode', qrUrl);
        this.qrcode('qrcode2', qrUrl);
        this.$nextTick(() => {
          this.generateShareImage();
        });
      }, 500)
    },
    handleDrawClick() {
      if (!this.checkLogin()) {
        return;
      }
      // 防止点击动画与提示动画冲突
      if (this.isAnimating) return;
      this.isAnimating = true;

      // 清除当前提示动画
      this.isDrawHint = false;

      // 弹出商店弹窗
      this.popSwitch('shopShow', true);

      // 动画持续 500ms 后复位 isAnimating 状态
      setTimeout(() => {
        this.isAnimating = false;
      }, 500);
    },
    startDrawHintLoop() {
      this.drawHintTimer = setInterval(() => {
        if (!this.isAnimating) {
          this.isDrawHint = true;
          setTimeout(() => {
            this.isDrawHint = false;
          }, 1200); // 1.2秒的提示动画时间
        }
      }, 3000);
    },

    // 领取接口
    async claimReward(task) {
      if (!this.checkLogin()) {
        return;
      }
      const { id: task_id, status } = task;

      // ⛔ 未完成：不可领取
      if (status === 0) {
        this.onToast('请先在游戏中完成任务');
        return;
      }

      // ✅ 任务已完成，不需要再点击领取（冗余检测）
      if (status === 2) {
        this.onToast('任务已完成');
        return;
      }

      // ✅ 正常领取流程（status === 1）
      const res = await onGetRewardAPI({ task_id });

      if (Number(res.code) === 200) {
        // 刷新任务列表（或局部状态）
        this.batchSetActivityData(res.data.activity, ['task_info']);
        this.onToast(`完成任务，古玉+${task_id === 5 ? 15 : 5}`);
      } else {
        this.onToast(res.message);
      }

    },
    hasHistory() {
      if (!this.checkLogin()) {
        return;
      }
      if (this.score_record_list.length == 0) {
        this.noRecordShow = true
      } else {
        this.recordShow = true
      }
    },
    closeEmpty() {
      this.emptyShow = false
      this.shopShow = false
    },
    // 确认购买按钮
    async confirmBuy() {
      const res = await onBuyItemAPI({ prop_id: this.click_item.id, number: 1 });

      if (Number(res.code) === 200) {
        // 刷新任务列表（或局部状态）
        this.batchSetActivityData(res.data.activity);

        this.onToast('购买成功!')
        this.buyItemShow = false
      } else {
        this.onToast(res.message);
      }
    },
    buyItem(item) {
      if (this.total_money < item.number) {
        this.emptyShow = true
        // 铜币不足前往历练弹窗
      } else {
        this.click_item = item
        this.buyItemShow = true
      }
    },
    unlockPackageLayer(layerNumber) {
      // layerNumber: 1 表示第一层，2 表示前两层
      const limitIndex = layerNumber * 3;
      this.package_info = this.package_info.map((item, index) => {
        if (index < limitIndex) {
          return { ...item, is_lock: false };
        }
        return item;
      });
    },
    toggleTab() {
      this.activeTab = this.activeTab === 'tab1' ? 'tab2' : 'tab1';
    },
    beforeDestroy() {
      clearInterval(this.drawHintTimer);
    },
    onBeforeEnter() {
      this.animating = true;
    },
    onAfterLeave() {
      this.animating = false; // 动画结束后，隐藏整个容器
    },
    // 首屏动画进度
    incrementTo100() {
      const target = 100;
      const duration = 2500; // 持续时间1秒
      const stepTime = duration / target; // 每一步的时间间隔
      const that = this;
      const intervalId = setInterval(() => {
        that.count += 1;
        if (that.count >= target) {
          clearInterval(intervalId); // 当达到100时停止计时器
        }
      }, stepTime);
    },
    qrcode(id, link) {
      generateQRCode(document.getElementById(id), {
        text: link,
        colorDark: '#914d2e',
        colorLight: '#f3eadb'
      });
    },
    // 分享图片设置
    generateShareImage() {
      Indicator.open();
      generateCanvasImage(this.$refs.imageDom)
        .then((canvas) => {
          Indicator.close();
          console.log(canvas, 'canvas')
          this.preventShow = false;
          this.shareShow = true
          this.shareImg = canvas.toDataURL('image/png'); // 可将 canvas 转为 base64 格式
          console.log('success: 图片生成成功');
        })
        .catch((err) => {
          Indicator.close();
          this.preventShow = false
          console.log('err: 图片生成失败', err.message);
        });
    },
    popSwitch(name, state) {
      this[name] = state;
    },
    switchTab(tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab
      }
    },
    qhBtn() {
      this.logoutShow = true
    },
    logoutBtn() {
      LogoutAPI().then((response) => {
        if (Number(response.code) === 200) {
          // 清空数据 控制弹窗
          window.localStorage.setItem("access_token", "");
          this.clearAllData()
          this.osCancel()
          this.logoutShow = false
          this.setInitUserInfo();
          this.setInitActiveInfo();
          this.changeLoginPopup(true);
        }
      });
    },
    clearAllData() {
      this.shopName = ''// 别人的当铺名
      this.can_buy_number = '' // 每日上限
      this.other_can_buy_number = '' // 别人的每日上限
      this.other_now_can_sell_number = '' // 别人还能卖多少
      this.userId = '' // 用户邀请的id
      this.helpId = '' // 判断tab
      this.now_shop_price = '' // 今天别人商店的玉价
      this.today_price = ''// 今天的玉价
      this.now_can_sell_number = ''
      this.isAnimating = false //  下拉动画
      this.currentSellCount = 0
      this.total_money = '' // 铜钱
      this.total_score = '' // 古龙
      this.score_record_list = []
      this.recordShow = false
      this.noRecordShow = false
      this.sellShow = false // 出售古龙
      this.otherSellShow = false // 链接出售古玉
      this.emptyShow = false // 铜币不足弹窗
      this.click_item = '' // 当前点击选中的item 就是商店购买的 
      this.package_info = []
      this.task_info = [
        { id: 1, desc: '今日完成1次游戏登录', status: 0 },
        { id: 2, desc: '今日完成1次组队副本', status: 0 },
        { id: 3, desc: '今日完成1次比武大会', status: 0 },
        { id: 4, desc: '挑战1次世界悬赏', status: 0 },
        { id: 5, desc: '打开1次仙盟宴会伴手礼', status: 0 },
      ]
      this.buyItemShow = false// 是否需要购买此物品
      this.shopShow = false //商店弹窗
      this.ruleShow = false // 规则弹窗
      this.activeTab = 'tab1' // 默认选中“图鉴”tab
      this.eggShow = false   // 控制是否弹出
      this.animating = false   // 控制父容器是否仍显示
      this.headerLogin = false
      this.gameName = 'hjwq'
      this.shareImg = ''
      this.user_info = {}// 用户信息
      this.shareShow = false
      this.logoutShow = false
    },
    goLink(url) {
      window.location.href = url;
    },
    // 复制链接
    copyLink(copyName) {
      var _this = this
      const clipboard = new Clipboard(copyName)
      clipboard.on('success', (e) => {
        _this.onToast('复制成功')
        e.clearSelection()
      })
      clipboard.on('error', (e) => {
        _this.onToast('复制失败')
      })
    },
    isSetShare(linkUrl) {
      this.setShare({
        link: linkUrl + `${getTimeStamp()}`,
        title: '景天的唐家堡历练',
        imgUrl:
          'https://download4.qcplay.com/qcgame-api/XQRpm8ZqMZmpK8sTeMVOeI37Sjl08WjXdmdbLyr5.png',
        desc: '古玉滞销，救救景天！出售古玉得限定称号、洗练石、至尊召唤券等好礼。',
      })
    },
    // 登录校验
    checkLogin() {
      if (!this.user_info.user_id) {
        this.changeLoginPopup(true)
        this.onToast('请先登录')
        return false
      }
      return true
    },
    onBind() {
      this.clearAllData()
      this.onInit();


      const params = analysisParams(window.location.href);
      this.helpId = params.help_id

      if (params.help_id) {
        this.activeTab = 'tab3'
        onHelpInitAPI({ help_id: this.helpId }).then((response) => {
          if (Number(response.code) === 200) {
            this.now_shop_price = response.data.activity.now_shop_price
            this.other_now_can_sell_number = response.data.activity.now_can_sell_number
            this.other_can_buy_number = response.data.activity.can_buy_number
            this.shopName = response.data.activity.shop_name
          } else {
            Number(response.code) !== 401 && this.onToast(response.message);
          }
        });
      }
    },
    logon() {
      this.changeLoginPopup(true);
    },
    switchBtn() {
      this.changeOsPopup(true)
    },
    onInit() {
      onInitAPI().then((response) => {
        if (Number(response.code) === 200) {
          const { user_info } = response.data;
          this.headerLogin = true;
          this.onInitDataCallback(response);
          this.setUserInfo(user_info);
          this.user_info = user_info;

          this.total_money = response.data.activity.total_money
          this.total_score = response.data.activity.total_score
          this.task_info = response.data.activity.task_info
          this.package_info = response.data.activity.package_info

          this.can_buy_number = 20
          this.now_can_sell_number = response.data.activity.now_can_sell_number
          this.score_record_list = response.data.activity.score_record_list
          this.today_price = response.data.activity.today_price
          this.userId = response.data.activity.code

        } else {
          Number(response.code) !== 401 && this.onToast(response.message);
        }
      });
    },

    goOfficeWeb() {
      // 跳转官网 
      setTimeout(() => {
        window.location = this.downloadUrl;
      }, 250);
    },
    // 注销
    osCancel() {
      this.user_info = {}
      this.headerLogin = false
      this.clearAllData()
    },
    // TAG: 其他简易封装的方法
    onToast(config) {
      const curConfig = {
        duration: 1000,
        className: 'toasts'
      };
      if (!config) {
        console.error('缺少config参数');
        return false;
      }
      if (typeof config === 'string') {
        curConfig.message = config;
      }
      Toast(curConfig);
    },

    ...mapMutations([
      'changeLoginPopup',
      'changeOsPopup',
      'setInitActiveInfo',
      'setUserInfo',
      'setInitUserInfo',
      'setLogger'
    ]),
    ...mapActions([
      'onInitDataCallback',
      'setShare'
    ])
  }
}
</script>

<style lang="less">
@import url("./index.less");
</style>



// WEBPACK FOOTER //
// src/pages/hjwq/aniEvent/index/index.vue